import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { CHANGE_TAB } from "../../constants/actionTypes";
import { commonService } from "../../Network/services/commonService";
import { useLocation, useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import Files from "react-files";

import { LoadingOverlay, Loader } from "react-overlay-loader";
import { ToastContainer, toast } from "react-toastify";
import TagsInput from "react-tagsinput";
import DatePicker from "react-datepicker";
import moment from "moment";
import Modal from "react-modal";

import "react-datepicker/dist/react-datepicker.css";
import "react-tagsinput/react-tagsinput.css";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-dropdown-select";
const mapStateToProps = (state) => ({
  ...state.articleList,
});

const mapDispatchToProps = (dispatch) => ({
  onTabClick: (tab, pager, payload) =>
    dispatch({ type: CHANGE_TAB, tab, pager, payload }),
});

const PaymentView = (props) => {
  let location = useLocation();
  let history = useHistory();

  const [profile, setProfile] = useState({});
  const [name, setName] = useState("");
  const [withdrawalsList, setWithdrawalsList] = useState([]);
  const [addedToWalletList, setAddedToWalletList] = useState([]);
  const [walletAmount, setWalletAmount] = useState("");

  const [loading, setLoading] = useState(false);
  const [walletLoading, setWalletLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('withdraw');
  useEffect(() => {
   
    let user = JSON.parse(window.localStorage.getItem("UserData"));

    getWalletAmount();
    getQuoteList();
    setName(user.first_name + " " + user.last_name);
    let personal_preference_name1_array = user.personal_preference_name1.split(
      ","
    );
  }, []);

  let back = (e) => {
    e.preventDefault();
    history.goBack();
  };

  const redirect = () => {
    history.push("/ExperienceUpdate");
  };
  const getWalletAmount = () => {
    setWalletLoading(true)
    const FormData = require("form-data");

    const form = new FormData();

    commonService
      .CommonService("wallet", form)
      .then(async (res) => {
        if (res.status == 200) {
          setWalletAmount(res.wallet)
        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success("Something went wrong! please try again later!!", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        setWalletLoading(false)
      });
  };
  // Maps API response: res.data -> withdrawals, res.deposit_history -> added to wallet
  const getQuoteList = () => {
    setLoading(true);
    
    const FormData = require("form-data");
    const form = new FormData();

    commonService
      .CommonService("withdraw_payment_history", form)
      .then(async (res) => {
        if (res.status == 200) {
          const mappedWithdrawals = (res.data || []).map(item => ({
            id: item.id,
            transaction_id: item.transfer_id ? item.transfer_id.slice(item.transfer_id.indexOf('_Id') + 3) : item.transfer_id || '', 
            amount: item.request_amount,
            date: moment(item.created_at).format("DD MMM YYYY"), 
            status: item.status === 'SUCCESS' ? 'Completed' : item.status, 
            pdf: item.pdf,
            description: 'Amount withdrawn' 
          }));
          setWithdrawalsList(mappedWithdrawals);

          const mappedDeposits = (res.deposit_history || []).map(item => {
            let sourceType = '';
            if (item.type === 'Deposit') {
              sourceType = 'From Escrow';
            } else if (item.type === 'Refund') {
              sourceType = 'From Refund';
            } else if (item.type === 'Referral') {
              sourceType = 'From Referral';
            } else {
              sourceType = `From ${item.type}`;
            }

            let description = '';
            if (item.type === 'Referral' && !item.job_id) {
              description = 'Amount added by GigFWS';
            } else if (item.job_id) {
              if (item.milestone_name) {
                description = `#Job ID : ${item.job_id} - ${item.milestone_name}`;
              } else {
                description = `#Job ID : ${item.job_id}`;
              }
            } else {
              description = `From ${item.type}`;
            }

            return {
              transaction_id: item.job_id || item.id,
              amount: item.requested_amount,
              sourceType: sourceType,
              description: description,
              date: moment(item.created_at).format("DD MMM YYYY"),
              status: item.status === 'SUCCESS' ? 'Completed' : item.status
            };
          });
          setAddedToWalletList(mappedDeposits);
        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success("Something went wrong! please try again later!!", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        setLoading(false);
      });   
  };

  const refreshPayoutStatus = (requestId) => {
    const FormData = require("form-data");
    const form = new FormData();
    form.append("request_id", requestId);

    commonService
      .CommonService("get_payout_status", form)
      .then(async (res) => {
        if (res.status == 200) {
          toast.success(res.message || "Payout status updated successfully", {
            position: "top-right",
            type: "success",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
          getQuoteList();
        } else {
          toast.success(res.message || "Failed to update payout status", {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success("Something went wrong! please try again later!!", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      });
  };

  
  return (
   
    <section className="post">
    <div className="container">
      <div className="banner paddimg-bottom">
      </div>
      <div className="quotes payments">
        <h1 className="title">Payments</h1>
        <div className="post-list earn">
          <div className="row payment-row">
            <div className="col-md-3 text-center">
              <img src="assets/images/PaymentWalletImage.svg" />
            </div>
            <div className="col-md-6">
              <h5>Total Earnings</h5>
              {walletLoading?<Loader loading={walletLoading}/>:<h1>₹ {walletAmount}</h1>}
              
              
              <p>As on {moment(new Date()).format("ddd MMM DD, YYYY")}</p>
            </div>
            <div className="col-md-3 text-center" onClick={()=>{
               if (walletAmount && parseFloat(walletAmount) > 0) {
                 history.push("/withdraw");
               }
            }}>
              <button className="withdraw-btn" disabled={!walletAmount || parseFloat(walletAmount) <= 0} style={{
                opacity: (!walletAmount || parseFloat(walletAmount) <= 0) ? 0.5 : 1,
                cursor: (!walletAmount || parseFloat(walletAmount) <= 0) ? 'not-allowed' : 'pointer'
              }}>Withdraw</button>
            </div>
          </div>
        </div>
          <div className="payment-tab-container">
            <div
              className={`payment-tab ${activeTab === 'withdraw' ? 'payment-active-tab' : ''}`}
              onClick={() => {
                setActiveTab('withdraw');
              }}
            >
              Withdrawals
            </div>
            <div
              className={`payment-tab ${activeTab === 'add-to-wallet' ? 'payment-active-tab' : ''}`}
              onClick={() => {
                setActiveTab('add-to-wallet');
              }}
            >
              Added to Wallet
            </div>
          </div>
          {activeTab === 'withdraw' && (
            <LoadingOverlay>
              {withdrawalsList.map((item, index) => {
                const getStatusClass = () => {
                  const status = item.status?.toLowerCase();
                  if (status === 'pending') return 'payment-status-pending';
                  if (status === 'completed' || status === 'success') return 'payment-status-completed';
                  if (status === 'failed') return 'payment-status-failed';
                  return 'payment-status-default';
                };
                const getDateLabel = () => {
                  return 'Withdrawn on';
                };
                const getDisplayStatus = () => {
                  const status = item.status?.toLowerCase();
                  if (status === 'success') return 'Completed';
                  return item.status || '';
                };
                return (
                  <div key={index} className="payment-transaction-card">
                    <div className="payment-transaction-header">
                      <div className="payment-transaction-id">TRANSACTION ID: {item.transaction_id}</div>
                      <div className="payment-transaction-right">
                        <div className={`payment-transaction-status ${getStatusClass()}`}>
                          {getDisplayStatus()}
                        </div>
                      </div>
                    </div>
                    <div className="payment-transaction-amount">₹ {item.amount}/-</div>
                    <div className="payment-transaction-description">{item.description}</div>
                    <div className="payment-transaction-footer">
                      <div className="payment-transaction-date">{getDateLabel()} {item.date}</div>
                      {(item.status === 'Completed' || item.status === 'SUCCESS') ? (
                        <a href={item.pdf} className="payment-download-link" target="_blank" rel="noopener noreferrer">
                          Download Invoice
                        </a>
                      ) : (item.status?.toLowerCase() === 'pending') ? (
                        <div className="payment-download-link" onClick={() => {
                          if (item.id) {
                            refreshPayoutStatus(item.id);
                          }
                        }}>
                          Refresh
                        </div>
                      ) : null}
                    </div>
                  </div>
                );
              })}
              <Loader loading={loading} />

            </LoadingOverlay>
          )}
          {activeTab === 'add-to-wallet' && (
            <LoadingOverlay>
              {addedToWalletList.map((item, index) => {
                const getStatusClass = () => {
                  const status = item.status?.toLowerCase();
                  if (status === 'pending') return 'payment-status-pending';
                  if (status === 'completed' || status === 'success') return 'payment-status-completed';
                  if (status === 'failed') return 'payment-status-failed';
                  return 'payment-status-default';
                };
                const getDisplayStatus = () => {
                  const status = item.status?.toLowerCase();
                  if (status === 'success') return 'Completed';
                  return item.status || '';
                };
                return (
                  <div key={index} className="payment-transaction-card">
                    <div className="payment-transaction-header">
                      <div className="payment-transaction-id">{item.sourceType}</div>
                      {item.status && (
                        <div className="payment-transaction-right">
                          <div className={`payment-transaction-status ${getStatusClass()}`}>
                            {getDisplayStatus()}
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="payment-transaction-amount">₹ {item.amount}/-</div>
                    <div className="payment-transaction-description">{item.description}</div>
                    <div className="payment-transaction-footer">
                      <div className="payment-transaction-date">Processed on {item.date}</div>
                    </div>
                  </div>
                );
              })}
              <Loader loading={loading} />
            </LoadingOverlay>
          )}
        </div>
      </div>
    </section>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentView);
